module.exports = __webpack_public_path__ + "static/media/circle-and-square.a9ab7c59.png";